import { ServiceMode } from 'state/order';

import { IsServiceModeValid } from './types';

export const isServiceModeValid: IsServiceModeValid = ({ serviceMode }) =>
  serviceMode !== ServiceMode.DELIVERY;
